<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div>
    <div class="tw-mb-2">
      <legend>
        {{ $t('Select your business entity type') }}
      </legend>

      <WdsRadioGroup v-model:checked="businessEntityType" name="business_entity">
        <WdsRadio value="fr_limited">
          <i class="input-helper"></i>
          {{ $t('Société') }}
          <br />
          <span class="c-gray small">
            {{ $t('If you have a limited company registered (SAS,SASU,EURL,SARL)') }}
          </span>
        </WdsRadio>

        <WdsRadio name="business_entity" value="fr_sole_trader">
          <i class="input-helper"></i>
          {{ $t('Entrepreneur individuel') }}
          <br />
          <span class="c-gray small">
            {{ $t('If you are registered as an “Auto-entreprise” or “Entreprise individuelle”') }}
          </span>
        </WdsRadio>
      </WdsRadioGroup>
    </div>

    <fieldset v-if="hasSelectedValidBusinessEntityType">
      <legend>
        {{ $t('Add your business details') }}
      </legend>

      <BusinessEntityInput
        v-model="businessName"
        :label="$t('Business name')"
        name="company_name"
      />

      <BusinessEntityInput
        v-model="siretNo"
        :label="$t('SIREN / SIRET')"
        name="company_no"
        maxlength="14"
      />

      <BusinessEntityInput
        v-model="cityOfRegistration"
        :label="$t('City of registration')"
        name="business_entity_data[city_of_registration]"
      />

      <BusinessEntityVat
        v-model:business-entity="internalBusinessEntity"
        :compliance-data="complianceData"
        class="m-t-10"
      />
    </fieldset>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <submit-button :text="$t('Save')" auto-submit class="m-t-20" />
  </div>
</template>

<script>
import { WdsRadio, WdsRadioGroup } from '@worksome/wds-components'

import gql from 'graphql-tag'
import { deepClone, setdefault } from '@/utils/tools'

import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import BusinessEntityVat from '@/components/compliances/BusinessEntity/BusinessEntityVat.vue'

export const fragments = {
  account: gql`
    fragment FreelancerFrBusinessEntityFormAccount on Account {
      name
    }
  `,
}

export default {
  name: 'FreelancerFrBusinessEntityForm',

  components: {
    WdsRadio,
    WdsRadioGroup,
    BusinessEntityInput,
    BusinessEntityVat,
  },

  props: {
    businessEntity: {
      type: Object,
      required: true,
    },

    complianceData: {
      type: Object,
      required: true,
    },

    freelancer: {
      type: Object,
      required: true,
    },
  },

  data() {
    const internalBusinessEntity = deepClone(this.businessEntity)

    return {
      internalBusinessEntity,
    }
  },

  computed: {
    hasSelectedValidBusinessEntityType() {
      return ['fr_limited', 'fr_sole_trader'].includes(this.businessEntityType)
    },

    businessEntityType: {
      get() {
        return this.internalBusinessEntity.entityType
      },

      set(value) {
        this.internalBusinessEntity.entityType = value
        this.$emit('update:businessEntity', this.internalBusinessEntity)
        if (value === 'fr_sole_trader') {
          this.businessName = this.freelancer.name
        }
      },
    },

    businessName: {
      get() {
        return this.internalBusinessEntity.companyName
      },

      set(value) {
        this.internalBusinessEntity.companyName = value
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },

    siretNo: {
      get() {
        return this.internalBusinessEntity.companyNo
      },

      set(value) {
        this.internalBusinessEntity.companyNo = value
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },

    cityOfRegistration: {
      get() {
        return this.internalBusinessEntity.data?.city_of_registration
      },

      set(value) {
        const data = setdefault(this.internalBusinessEntity, 'data', {})

        data.city_of_registration = value

        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
  },
}
</script>
